import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { LinkModule } from '@streamamg/components-lib';
import { RouterModule } from '@angular/router';
import { LoginButtonModule } from '../login-button/login-button.module';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    HeaderComponent,
  ],
  exports: [
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    LinkModule,
    RouterModule,
    LoginButtonModule,
    SharedModule,
    ReactiveFormsModule,
  ],
})
export class HeaderModule { }
